const Storage = function () {

    var storage = {},
        space = null,
        localStorageSupport = false;

    var __construct = function (gspace) {
        space = gspace;
        localStorageSupport = ("localStorage" in window);
        storage = getNamespace();
        if (!storage) {
            storage = {};
            return true;
        }
        //storage = $.evalJSON(storage);
        storage = JSON.parse(storage);
    };

    var getNamespace = function () {
        if (localStorageSupport) {
            return localStorage.getItem(space);
        }

        var stored = $.cookie();
        if (stored[space] == undefined) {
            return null;
        }
        return stored[space];
    };

    var saveNamespace = function () {
        var saving = JSON.stringify(storage);

        if (localStorageSupport) {
            localStorage.setItem(space, saving);
            return true;
        }

        $.cookie(space, saving, {path: "/", expire: "30"});
    };

    this.get = function (item) {
        var def = arguments[1] == undefined ? null : arguments[1];

        if (storage[item] == undefined) {
            return def;
        }
        return storage[item];
    };

    this.readKeys = function () {
        var keys = [];
        for (var i in storage) {
            keys.push(i);
        }
        return keys;
    };

    this.cleanStorage = function () {
        storage = {};
        saveNamespace();
        //localStorage.setItem(space, JSON.stringify({}));
    };

    this.set = function (item, value) {
        storage[item] = value;
        saveNamespace();
        //var saving = $.toJSON(storage);
        //localStorage.setItem(space, saving);
    };
    __construct.apply(this, arguments);
};

export default Storage;






// WEBPACK FOOTER //
// ./src/lib/storage.js